if (!customElements.get('tabbed-description')) {
  customElements.define(
    'tabbed-description',

    class tabbedDescription extends HTMLElement {
      constructor() {
        super();

        this.buttons = [...this.querySelectorAll('.tab button')];
        this.buttons[0]?.classList.add('active-content');

        this.buttons.forEach((button) => button.addEventListener('click', this.handleTabSwitch.bind(this)));
      }

      handleTabSwitch(e) {
        if (e.target.classList.contains('active-tab')) return;

        const targetEl = e.target;

        this.querySelector('.tablinks.active-tab')?.classList.remove('active-tab');
        this.querySelector('.tabcontent.active-content')?.classList.remove('active-content');

        targetEl?.classList.add('active-tab');
        const newTabId = targetEl.id.replace('tab-', 'tabcontent-');
        this.querySelector(`#${newTabId}`)?.classList.add('active-content');
      }
    }
  );
}
